import React, { useEffect } from "react";
import { formatSecondGetTime } from "../../utils/formatSecondGetTime";
import { useCountdown } from "../../hooks/useCountdown";
import { useExam } from "../../context/ExamContext";
import { FaBook, FaClock, FaInfoCircle, FaArrowRight, FaCheckCircle } from "react-icons/fa";

const ReadingIntro = ({ onStart, timeLeft, isDemoExam }) => {
    const { uprId } = useExam();

    useEffect(() => {
        // Prevent scrolling
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = "auto"; // Reset on unmount
        };
    }, []);
    const countingTimeLeft = useCountdown();

    return (
        <div className="flex justify-center items-center min-h-screen sectionIntros" style={{ backgroundColor: 'var(--background-color)', zIndex: 9999 }}>
            <div className="w-4/5 max-w-4xl bg-var(--background-color) border border-var(--border-color) shadow-2xl rounded-2xl p-12 text-center relative overflow-hidden">
                {/* Decorative background elements */}
                <div className="absolute top-4 right-4 w-16 h-16 bg-[#FC532B] rounded-full opacity-20"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 bg-[#FC532B] rounded-full opacity-15"></div>

                {/* Header Section */}
                <div className="mb-10">
                    <div className="flex items-center justify-center mb-6">
                        <div className="w-20 h-20  bg-[#FC532B] rounded-full flex items-center justify-center mr-6 shadow-lg">
                            <FaBook className="faBook text-3xl" />
                        </div>
                        <div className="text-left">
                            <h2 className="text-4xl font-bold text-var(--text-color) mb-2">IELTS Academic Reading</h2>
                            <div className="flex items-center text-var(--text-color) opacity-70">
                                <FaClock className="mr-3 text-[#FC532B]" />
                                <span className="font-medium text-lg">Duration: 60 minutes</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Single Card Content */}
                <div className="bg-var(--background-color) border border-var(--border-color) p-8 rounded-xl border-l-4  mb-8">
                    <div className="grid md:grid-cols-2 gap-8">
                        {/* Instructions Section */}
                        <div className="text-left">
                            <h3 className="font-bold text-xl text-[#FC532B] mb-6 flex items-center">
                                <FaInfoCircle className="mr-3 text-[#FC532B]" />
                                INSTRUCTIONS TO CANDIDATES
                            </h3>
                            <div className="space-y-4">
                                <div className="flex items-start group">
                                    <FaCheckCircle className="text-[#FC532B] mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="text-var(--text-color) leading-relaxed">Read the instructions for each question type carefully.</span>
                                </div>
                                <div className="flex items-start group">
                                    <FaCheckCircle className="text-[#FC532B] mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="text-var(--text-color) leading-relaxed">Answer <strong className="text-[#FC532B]">all</strong> the questions in the time allowed.</span>
                                </div>
                                <div className="flex items-start group">
                                    <FaCheckCircle className="text-[#FC532B] mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="text-var(--text-color) leading-relaxed">You can navigate between questions and passages.</span>
                                </div>
                                <div className="flex items-start group">
                                    <FaCheckCircle className="text-[#FC532B] mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="text-var(--text-color) leading-relaxed">Use the scroll bar to read the full text of each passage.</span>
                                </div>
                                <div className="flex items-start group">
                                    <FaCheckCircle className="text-[#FC532B] mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="text-var(--text-color) leading-relaxed">You can highlight text and make notes as you read.</span>
                                </div>
                            </div>
                        </div>

                        {/* Information Section */}
                        <div className="text-left">
                            <h3 className="font-bold text-xl text-[#FC532B] mb-6 flex items-center">
                                <FaInfoCircle className="mr-3 text-[#FC532B]" />
                                INFORMATION FOR CANDIDATES
                            </h3>
                            <div className="space-y-4">
                                <div className="flex items-start group">
                                    <FaCheckCircle className="text-[#FC532B] mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="text-var(--text-color) leading-relaxed">There are <strong className="text-[#FC532B]">3 passages</strong> and a total of <strong className="text-[#FC532B]">40 questions</strong>.</span>
                                </div>
                                <div className="flex items-start group">
                                    <FaCheckCircle className="text-[#FC532B] mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="text-var(--text-color) leading-relaxed">Each correct answer receives <strong className="text-[#FC532B]">1 mark</strong>.</span>
                                </div>
                                <div className="flex items-start group">
                                    <FaCheckCircle className="text-[#FC532B] mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="text-var(--text-color) leading-relaxed">The passages are academic texts from books, journals, and magazines.</span>
                                </div>
                                <div className="flex items-start group">
                                    <FaCheckCircle className="text-[#FC532B] mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="text-var(--text-color) leading-relaxed">Question types include multiple choice, matching, and completion tasks.</span>
                                </div>
                                <div className="flex items-start group">
                                    <FaCheckCircle className="text-[#FC532B] mt-1 mr-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                                    <span className="text-var(--text-color) leading-relaxed">You can review and change your answers before submitting.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Action Section */}
                <div className="flex flex-col items-center">
                    {timeLeft !== 0 && timeLeft != null && timeLeft !== undefined ? (
                        <div className="bg-[#FC532B] text-white px-10 py-5 rounded-full shadow-lg">
                            <p className="font-semibold text-xl">Exam will start in {formatSecondGetTime(countingTimeLeft)} seconds...</p>
                        </div>
                    ) : (
                        <button
                            className="bg-[#FC532B] hover:bg-[#e04a26] text-white font-bold px-10 py-5 rounded-full shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center text-lg"
                            onClick={onStart}
                        >
                            <FaArrowRight className="mr-3" />
                            Continue to Exam
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReadingIntro;